export const BRAND = {
  name: "Videosbolt",
  studio: "Digit-Studio",
  phone: "+36 50 104 2008",
  phoneHref: "tel:+36501042008",
  email: "info@videosbolt.com",
  emailHref: "mailto:info@videosbolt.com",
  hours: "Hétfő–Szombat · 9:00–18:00",
  address: "1194 Budapest, Vas Gereben utca 211",
  mapsUrl: "https://www.google.com/maps/search/?api=1&query=Digit-Studio+1194+Budapest+Vas+Gereben+utca+211",
  // Fallback "leave a review" URL when Place ID is not yet resolved by backend.
  // Once /api/reviews/google returns a place_id, the UI prefers the official write-review URL.
  writeReviewFallbackUrl: "https://www.google.com/maps/place/Digit-Studio/@47.440822,19.136336,17z/data=!3m1!4b1!4m6!3m5!1s0x4741dbe2537a9561:0x57afbd9a36aa17f4!8m2!3d47.4408184!4d19.1389163!16s%2Fg%2F11qg37mx82",
  tagline: "Az emlékek őrzője",
};
